var elAnimations = {
  load:function(){
    this.imageHeightScroll();
    this.fixedScroll();
  },
  imageHeightScroll:function(){
    var imgs = document.querySelectorAll("[data-imageHeightScroll]");

    var saveImageHeight = (element) => {
      var imageHeight = element.offsetHeight;
      if(imageHeight == 0){
        setTimeout(function(){ saveImageHeight(element); },100);
      }
      else{
        element.setAttribute("data-height",imageHeight);
      }
    }
    for(let i of imgs){

      saveImageHeight(i);

    }

    window.addEventListener("scroll",function(){
      var imgs = document.querySelectorAll("[data-imageHeightScroll]");
      for(let i of imgs){

          var newHeight = parseInt(i.getAttribute("data-height"))-(window.scrollY/parseInt(i.getAttribute("data-imageHeightScroll")));

          if(newHeight > parseInt(i.getAttribute("data-imageHeightScrollMin"))){
            i.style.height = newHeight + "px";
          }
          else{
            i.style.height = i.getAttribute("data-imageHeightScrollMin") + "px";
          }
      }
    });
  },
  fixedScroll:function(){
    var divs = document.querySelectorAll("[data-fixedScroll]");
    for(let d of divs){
        var bounds = d.getBoundingClientRect();
        var top = bounds.top + window.scrollY;
        if(d.getAttribute("data-fixedScrollOffset")){
          top = top - parseInt(d.getAttribute("data-fixedScrollOffset"));

        }
        d.setAttribute("data-topFixed",top);

        var spacerID = "topFixedSpacer_"+Math.floor(Math.random()*600+500);
        var spacer = document.createElement("div");
        spacer.setAttribute("id",spacerID);
        d.parentNode.insertBefore(spacer,d);
        //document.body.prepend(spacer);
        spacer.style.width = "100%";
        spacer.style.display = "none";
        spacer.style.height = d.offsetHeight + "px";

        d.setAttribute("data-topFixedSpacer",spacerID);
    }
    window.addEventListener("scroll",function(){
      var divs = document.querySelectorAll("[data-fixedScroll]");
      for(let d of divs){
        var spacer = document.getElementById(d.getAttribute("data-topFixedSpacer"));
        var bounds = d.getBoundingClientRect();
        var top = bounds.top + window.scrollY;
        if(d.getAttribute("data-fixedScrollOffset")){
          top = top - parseInt(d.getAttribute("data-fixedScrollOffset"));

        }
        if(window.scrollY >= top && !d.classList.contains("fixedScroll")){
          d.setAttribute("data-topFixed",top);
            d.classList.add("fixedScroll");
            if(spacer.style.display == "none"){
              spacer.style.display = "block";
              spacer.style.height = d.offsetHeight + "px";
            }

          }
          if(window.scrollY < parseInt(d.getAttribute("data-topFixed"))) {
            d.classList.remove("fixedScroll");
            spacer.style.display ="none";
          }
      }
    });
  }
}

window.addEventListener("DOMContentLoaded",function(){
  elAnimations.load();
});
